import React, { useState } from 'react';
import { Restaurant } from '../types';
import './SelectRestaurant.css';

export type { Restaurant };

interface SelectRestaurantProps {
  restaurants: Restaurant[];
  onSelect: (restaurant: Restaurant) => void;
}

const SelectRestaurant: React.FC<SelectRestaurantProps> = ({ restaurants, onSelect }) => {
  const [selectedId, setSelectedId] = useState<string>('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!selectedId) return;
    
    const restaurant = restaurants.find(r => r.restaurantId === selectedId);
    if (restaurant) {
      onSelect(restaurant);
    }
  };

  const formatAddress = (address?: SelectRestaurantProps['restaurants'][0]['address']): string => {
    if (!address) return '';
    const parts = [address.street, address.number, address.neighborhood, address.city, address.state]
      .filter(Boolean);
    return parts.join(', ');
  };

  return (
    <div className="select-restaurant-page">
      <div className="select-restaurant-container">
        <div className="select-restaurant-header">
          <div className="select-restaurant-logo">
            <span className="select-restaurant-logo-icon">✓</span>
            <span className="select-restaurant-logo-text">FidHub Admin</span>
          </div>
          <h1>Selecione seu restaurante</h1>
          <p>Você possui acesso a múltiplos restaurantes. Escolha qual deseja administrar agora.</p>
        </div>

        <form onSubmit={handleSubmit} className="select-restaurant-form">
          <div className="form-group">
            <label htmlFor="restaurant">Restaurante</label>
            <select
              id="restaurant"
              value={selectedId}
              onChange={(e) => setSelectedId(e.target.value)}
              className="restaurant-select"
              required
            >
              <option value="">-- Selecione um restaurante --</option>
              {restaurants.map((restaurant) => (
                <option key={restaurant.restaurantId} value={restaurant.restaurantId}>
                  {restaurant.name}
                </option>
              ))}
            </select>
          </div>

          {selectedId && (
            <div className="restaurant-preview">
              {(() => {
                const selected = restaurants.find(r => r.restaurantId === selectedId);
                if (!selected) return null;
                return (
                  <div className="preview-card">
                    <div className="preview-header">
                      <h3>{selected.name}</h3>
                    </div>
                    <div className="preview-details">
                      {selected.phone && (
                        <div className="preview-detail">
                          <span className="preview-icon">📞</span>
                          <span>{selected.phone}</span>
                        </div>
                      )}
                      {selected.email && (
                        <div className="preview-detail">
                          <span className="preview-icon">📧</span>
                          <span>{selected.email}</span>
                        </div>
                      )}
                      {selected.address && formatAddress(selected.address) && (
                        <div className="preview-detail">
                          <span className="preview-icon">📍</span>
                          <span>{formatAddress(selected.address)}</span>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })()}
            </div>
          )}

          <button type="submit" className="select-restaurant-button">
            Continuar
          </button>
        </form>
      </div>
    </div>
  );
};

export default SelectRestaurant;


